import React from "react";
import { Outlet } from "react-router-dom";

import { Box, Grid } from "@mui/material";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";

export const AdminNoPaddingPageProvider = () => {
  return (
    <Box
      id={"standard-no-padding-page-provider-box"}
      sx={{
        display: "flex",
        marginLeft: "auto",
        marginRight: "auto",
        // backgroundColor: "#F5F5F5",
        maxWidth: "none",
      }}
    >
      <NavigationDrawer isUnauthorized={false} />
      <Grid item sx={{ width: "-webkit-fill-available" }}>
        <Outlet />
      </Grid>
    </Box>
  );
};
